"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelmetSet = void 0;
const react_1 = __importDefault(require("react"));
const react_helmet_1 = require("react-helmet");
/* Generate favicon in https://www.favicon-generator.org/ */
/* eslint @typescript-eslint/no-require-imports: "off" */
const HelmetSet = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(react_helmet_1.Helmet, { link: [
            {
                rel: 'apple-touch-icon',
                href: require('@App/assets/favicon/apple-icon-57x57.png'),
                sizes: '57x57',
            },
            {
                rel: 'apple-touch-icon',
                href: require('@App/assets/favicon/apple-icon-60x60.png'),
                sizes: '60x60',
            },
            {
                rel: 'apple-touch-icon',
                href: require('@App/assets/favicon/apple-icon-72x72.png'),
                sizes: '72x72',
            },
            {
                rel: 'apple-touch-icon',
                href: require('@App/assets/favicon/apple-icon-76x76.png'),
                sizes: '76x76',
            },
            {
                rel: 'apple-touch-icon',
                href: require('@App/assets/favicon/apple-icon-114x114.png'),
                sizes: '114x114',
            },
            {
                rel: 'apple-touch-icon',
                href: require('@App/assets/favicon/apple-icon-120x120.png'),
                sizes: '120x120',
            },
            {
                rel: 'apple-touch-icon',
                href: require('@App/assets/favicon/apple-icon-144x144.png'),
                sizes: '144x144',
            },
            {
                rel: 'apple-touch-icon',
                href: require('@App/assets/favicon/apple-icon-152x152.png'),
                sizes: '152x152',
            },
            {
                rel: 'apple-touch-icon',
                href: require('@App/assets/favicon/apple-icon-180x180.png'),
                sizes: '180x180',
            },
            {
                rel: 'icon',
                type: 'image/png',
                href: require('@App/assets/favicon/android-icon-192x192.png'),
                sizes: '192x192',
            },
            {
                rel: 'icon',
                type: 'image/png',
                href: require('@App/assets/favicon/favicon-32x32.png'),
                sizes: '32x32',
            },
            {
                rel: 'icon',
                type: 'image/png',
                href: require('@App/assets/favicon/favicon-96x96.png'),
                sizes: '96x96',
            },
            {
                rel: 'icon',
                type: 'image/png',
                href: require('@App/assets/favicon/favicon-16x16.png'),
                sizes: '16x16',
            },
        ], meta: [
            { name: 'msapplication-TileColor', content: '#ffffff' },
            { name: 'msapplication-TileImage', content: '@App/assets/favicon/ms-icon-144x144.png' },
        ] })));
exports.HelmetSet = HelmetSet;
